import { render, staticRenderFns } from "./gamePackage.vue?vue&type=template&id=1e57397d&"
import script from "./gamePackage.vue?vue&type=script&lang=js&"
export * from "./gamePackage.vue?vue&type=script&lang=js&"
import style0 from "./gamePackage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports